import VideoPreview from "./VideoPreview";

const WebinarVideo = ({ videoLink, videoAutoplay }) => {

    let videoType = '';
    let videoId = '';

    if (videoLink.includes('youtube.com')) {
        videoType = 'youtube';
        videoId = new URL(videoLink).searchParams.get('v');
    } else if (videoLink.includes('vimeo.com')) {
        videoType = 'vimeo';
        videoId = videoLink.split('/').pop();
    } else {
        return <p>Invalid video link</p>;
    }

    return (
        <VideoPreview
            type={videoType}
            videoId={videoId}
            width="724"
            height="407"
            autoplay={videoAutoplay}
        />
    );
};

export default WebinarVideo;
